export default {
  dashboardData: null,
  dashboardLoading: false,
  dashboardError: null,
  sellerTicketCount: 0,
  n11TicketCount: 0,
  SELLER_SHOP: {
    companyTitle: "",
    fastSellerBadge: false,
    lateShipmentCount: 0,
    logo: "",
    negativeCommentCount: 0,
    officialSeller: false,
    rejectedItemCount: 0,
    sellerScore: null,
    storeName: "",
    topSellerBadge: false,
  },
};
